import { Injectable } from "@angular/core";

import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn:'root'
})
export class CartService{
    constructor(private http:HttpClient){}
    private _setOrderUrl="http://brideselection.com/gouud/api/order/setOrder/";
    private _orderInfoUrl="http://brideselection.com/gouud/api/order/setUserInfo";
    private _addOrderUrl="http://brideselection.com/gouud/api/order/finishOrder/";
    setOrder(id,order){
      return  this.http.post(`${this._setOrderUrl}${id}`,order ).pipe(map(res=>res['data']))
    }
    orderInfo(order){
        return  this.http.post(this._orderInfoUrl,order ).pipe(map(res=>res['data']))
    }
    addOrder(id,payment){
        return this.http.post(`${this._addOrderUrl}${id}`,payment).pipe(map(res=>res['data']))
    }
}